import * as yup from 'yup'

import { LoadingStatus } from 'helpers/common'
import type { IUserInfoProps, IState } from './model'
import i18n from 'config/i18n'

export const initial: IState = {
  status: LoadingStatus.Pending,
  user: null,
  error: null,
}

export const failureState = (error: string): IState => ({
  status: LoadingStatus.Failure,
  user: null,
  error: JSON.stringify(error),
})

export const successState = (info: IUserInfoProps): IState => ({
  status: LoadingStatus.Success,
  user: info,
  error: null,
})

export const schemaLoginForm = yup.object().shape({
  email: yup.string().required(i18n.t('login:username.required')),
  password: yup.string().required(i18n.t('login:password.required')),
})

export const initialLoginForm = {
  email: '',
  password: '',
  isRemember: false,
  errors: {},
}
